<ndt-login-view
   [appStartCallState]="appStartCallState"
   [loginCallState]="loginCallState"
   [username]="username$ | async"
   (loginClicked)="onLoginClick($event)"
   (cannotSignInClicked)="onCannotSignInClick()"
   (loginWithSSO)="onLoginWithSSO()"
   [loginError]="loginError$ | async"
   [hasSaml2Authentication]="hasSaml2Authentication$ | async"
></ndt-login-view>
